/* eslint-disable react/prop-types */
import { Space, Typography } from "antd";
import { format } from "date-fns";

export default function UpdatedByCell({ value }){
  return (
    <Space direction="vertical" size={2} >
      <Typography.Text style={{ marginBottom: 0, fontWeight: 400 }} >
        {value.updatedBy}
      </Typography.Text>
      <Typography.Text type="secondary" >
        {format(new Date(value.updatedAt), 'dd/MM/yyyy - HH.mm')}
      </Typography.Text>
    </Space>
  )
}